var generic = generic || {};
(function($) {

  /**
   * Make the necessary toolbar adjustments to the #top region, which is fixed position
   */
  Drupal.behaviors.toolbarAdjustments = {
    doAdjustments: function() {
      var e = Drupal.cl.getElements();
      // NOTE: the sticky bar will place the e.top at -115px when in effect - so we check for this before re-adjusting
      if (e.body.hasClass('toolbar') && e.top.css('position') == 'fixed' && e.top.css('top') != '-115px') {
        var h = Drupal.cl.getToolbarHeight();

        if (h > 0) {
          e.top.css({ 'top': h + 'px' });
        }
      }
    },

    init: function() {
      var self = this;

      self.doAdjustments();
      $(window).resize(function() {
        self.doAdjustments();
      });
    },

    attach: function(context, settings) {
      this.init();
    }
  };


  /**
   * Set the top of the #main element if/when #top if fixed
   */
  Drupal.behaviors.fixedHeaderAdjustments = {
    doAdjustments: function() {
      var e = Drupal.cl.getElements();
      var properties = {};

      // Only set padding on #main when #top has fixed position
      if (e.top.css('position') == 'fixed') {
        var h = Drupal.cl.getTopHeight();

        // The toolbar already adds a padding-top to the body element, which means
        // I don't need account for it's height manually.
        // if (e.body.hasClass('toolbar')) {
        //   h += Drupal.cl.getToolbarHeight();
        // }

        properties['padding-top'] = h + 'px';
      }

      // IE-friendly way to only apply properties when they exist
      var length = 0;
      for (prop in properties) {
        if (properties.hasOwnProperty(prop)) {
          length++;
        }
      }
      if (length > 0) {
        e.main.css( properties );
      }
    },

    init: function() {
      var self = this;

      self.doAdjustments();
      $(window).resize(function() {
        self.doAdjustments();
      });
    }

    /*
    attach: function(context, settings) {
      this.init();
    }
    */
  };

  /**
   * CAPS LOCK CHECKER/NOTIFIER
   * USES THIS PLUGIN https://github.com/azanov/jquery.capsChecker
   */
  Drupal.behaviors.capsChecker = {
    doAdjustments: function() {
      var textElements = $('.form-text');
      textElements.each(function() {
        var height = $(this).css('height');
        var width = $(this).width();
        var name = $(this).attr('name');
        var capsWarning = $('<span class="caps-warning" for="' + name + '">&#8682;</span>').css({
          'cursor': 'pointer',
          'display': 'none',
          'height': height,
          'line-height': height,
          'margin-left': width + 'px',
          'pointer-events': 'none',
          'position': 'absolute'
        });
        $(this).before(capsWarning);
      });

      textElements.capsChecker({
        capson: function(e, isOn) {
          $(this).siblings('.caps-warning').show();
        },
        capsoff: function(e, isOn) {
          $(this).siblings('.caps-warning').hide();
        }
      });
    },

    init: function() {
      var self = this;
      self.doAdjustments();
    },

    attach: function(context, settings) {
      this.init();
    }
  };

  /**
   * Apply placeholder plugin to input elements whose have placeholder attributes, to work around IE 8
   * and below limitations.
   * https://github.com/mathiasbynens/jquery-placeholder
   */
  Drupal.behaviors.placeholderPolyfill = {
    attach: function(context, settings) {
      $(document).ready(function() {
        var elements = $('input[placeholder], textarea[placeholder]');
        elements.placeholder();
      });
    }
  };

  /**
   * Apply textfill plugin to elements whose text should fill the dimensions of their parent container
   * http://stackoverflow.com/questions/687998/auto-size-dynamic-text-to-fill-fixed-size-container
   */
  Drupal.behaviors.bigText = {
    attach: function(context, settings) {
      $(document).ready(function() {
        var elements = $('.textfill');
        elements.each(function() {
          $(this).textfill({
            maxFontPixels: 36
          });
        });
      });
    }
  };

  Drupal.behaviors.isIpad = navigator.userAgent.match(/iPad/i) != null;

  Drupal.behaviors.launchBlueOcean = {
    // Presumably this method can be overwritten by a locale
    getPath: function() {
        return '/blue_ocean/quiz_overlay.tmpl';
    },

    launchBlueOcean: function(path) {
      var width = '780px',
          height = '525px',
          obHeight = 525;

      var overlayClass = 'ob_overlay';
      if (Drupal.behaviors.isIpad && $('html').width() < 962) {
        width = '760px';
        overlayClass = 'ob_overlay ipad_ob_overlay';
      }

      if(generic.env.isIE) {
        if(
            generic.env.isIE6 ||
            (((!(/opera|webtv/i.test(navigator.userAgent.toLowerCase())) && /msie\s(\d)/.test(navigator.userAgent.toLowerCase()))) && (RegExp.$1 == 7)) ||
            (((!(/opera|webtv/i.test(navigator.userAgent.toLowerCase())) && /msie\s(\d)/.test(navigator.userAgent.toLowerCase()))) && (RegExp.$1 == 8))
          ) {
            width = '500px';
            height = '100px';
            obHeight = 100;
        }
      }

      generic.template.get({
        path: path,
        forceReload: true,
        callback: function(html) {
          generic.overlay.launch({
            content: html,
            cssStyle: {width: width, height: height},
            cssClass: overlayClass
          });

          // Move the close icon based on viewport height
          var viewportHeight = $(window).height();
          var bufferHeight = 5;
          if (obHeight - viewportHeight > 0) {
            var moveCloseIcon = (obHeight - viewportHeight)/2 + bufferHeight + 'px';
            $('.ob_overlay .close-container').css('top', moveCloseIcon);
          }
        }
      });
    },

    attach: function(context, settings) {
      var self = this;

      $('.blueOceanQuizButton', context).once('bo-button-overlay').on('click', function() {
        var path = $(this).attr('href');
        if (typeof path === 'undefined' || path == '') {
          path = self.getPath();
        }

        self.launchBlueOcean(path);
        return false;
      });
    }
  };

  Drupal.behaviors.launchFoundationFinder = {
    // Presumably this method can be overwritten by a locale
    getPath: function() {
      return '/foundation_finder/frame.tmpl';
    },

    launchFoundationFinder: function(path) {
      generic.template.get({
        path: path,
        forceReload: true,
        callback: function(html) {
          generic.overlay.launch({
            content: html,
            cssStyle: { width: 'auto', height: 'auto' },
            cssClass: 'ff_overlay'
          });
        }
      });
    },

    attach: function(context, settings) {
      var self = this;
      var path = this.getPath();

      $('.foundationFinderQuizButton', context).once('ff-button-overlay').on('click', function() {
        self.launchFoundationFinder(path);
        return false;
      });
    }
  };

  // Basic/dumb older IE "polyfill"/stub, to un-break older versions of IE when console.log is called
  // JGA - I'm not sure why this is here when it already exists in the shared-main.js file
  if (!window.console) {
    window.console = {
      log: function () {}
    };
  }

  /**
   * Adjust footer CSS bottom property to auto when browser is resized
   */
  Drupal.behaviors.footerAdjustments = {
    hasRun: false,

    init: function() {
      function doAdjustments() {
        var $window = $(window),
            e = Drupal.cl.getElements(),
            $f = e.footer,
            winHeight = $window.height(),
            minWindowHeight = $('#top_wrapper, #top').outerHeight(true) + $('#wrapper, #main').outerHeight(true) + $f.outerHeight(true);
            // 220 is a buffer, the height of the expanded footer

        if (winHeight <= minWindowHeight) {
          $f.addClass('bottom-auto');
        }
        else {
          $f.removeClass('bottom-auto');
        }
      }

      var _doAdjustments = _.throttle(doAdjustments, 200);

      doAdjustments();
      $(window).resize(_doAdjustments);
    },

    attach: function(context, settings) {
      if (!this.hasRun) {
        this.init();
        this.hasRun = true;
      }
    }
  };

  Drupal.behaviors.msgOverlays = {
    attach: function(context, settings) {
      $(document).on('addToCart.success', function(e, cartResult) {
        var path = cartResult.ac_results && cartResult.ac_results.length ? cartResult.ac_results[0].result.OVERLAY : '';
        if (path && /^\//.test(path)) { //check that this is a path... else it's text and we should ignore
          generic.template.get({
            path:path,
            forceReload: true,
            callback: function(offerHtml) {
              generic.overlay.launch({
                content  : offerHtml,
                includeBackground: true,
                cssClass : 'offer-overlay'
              });
              // if this has fired, it means they added something from the overlay (clicks outside the overlay would close this anyway)
              $('.overlay-container').on('click', function() {
                generic.overlay.hide();
              });
            }
          });
        }
      });
    }
  }
})(jQuery);
$(document).ready(function(){
		var scrWidth=screen.width;
		var scrHeight=screen.height;
		var browser=navigator.appName;
		var b_version=navigator.appVersion;
		var version=b_version.split(";");
		var clIndex = window.location.href.indexOf('clinique');
		if($('#overlay-background').length)
		{
			return;
		}else{
			var appendDiv = $('<div class="overlay-background" id="overlay-background" style="display: none; height: 1498px; width: 1423px; POSITION: fixed;"></div>');
			$("body").append(appendDiv);
		}
		if(browser=="Microsoft Internet Explorer" && version[1] ==' MSIE 8.0' && clIndex>0){
			if($("#ie_version a").length)
			{
				return;
			}else
			{
				this.language = generic.rb("language");
				document.getElementById('overlay-background').style.display = 'block';
				var popupDiv = $('<div id="ie_version" style="POSITION: fixed; LEFT: 333px; TOP: 220px; z-index:10000;background-color:white"></div>');
				//var textHtml = '<div class="sitewide-ie-upgrade__content" style="text-align:center;padding:25px;"><p>เพื่อให้คุณได้สัมผัสประสบการณ์การใช้งานเว็บไซต์ของเราได้อย่างเต็มรูปแบบ เราขอแนะนำให้คุณอัพเกรดเวอร์ชั่นของบราวเซอร์ของคุณให้เป็นเวอร์ชั่นล่าสุด<br> หากต้องการดาวน์โหลดเพื่ออัพเกรดเป็นเวอร์ชั่นล่าสุด กรุณากดปุ่ม “อัพเกรด” ด้านล่าง</p><p></p><a class=button--secondary href="http://www.microsoft.com/en-us/download/internet-explorer.aspx" target=_blank>อัพเกรด</a> </div>';
				var textHtml = '<div class="sitewide-ie-upgrade__content" style="text-align:center;padding:25px;"><p>'+this.language.get("ie8_popup_msg")+'</p><p></p><a class=button--secondary href="http://www.microsoft.com/en-us/download/internet-explorer.aspx" target=_blank>'+this.language.get("ie_upgrade")+'</a> </div>';
				var closeBtnHtml='<a id="closeBlock" style="float:right; top:0px" href="Javascript: void(0)"></a>';
				$('body').append(popupDiv);
				document.getElementById("ie_version").innerHTML = closeBtnHtml + textHtml ;
				var midWidth = scrWidth/2-350;
				document.getElementById("ie_version").style.left= midWidth;
			}
		}
		$('#closeBlock').on('click', function () {
			document.getElementById('overlay-background').style.display = 'none';
			document.getElementById('ie_version').style.display = 'none';
    });
});